import { createDuck } from '@/utils/'

import { getWishActInfo, signUp } from '@/services/api/wish'
import { Toast } from 'antd-mobile'

//新人活动
export const duck = createDuck({
  name: 'wishComDuck',
  initialState: {
    actLoading: 0,
    // registrationInfoVo: {
    //   //活动报名信息 为null表示已报名
    //   registrationEndTime: new Date().getTime() + 2 * 60 * 60 * 1000,
    //   barrageList: [''],
    // },
    activityInfoVo: {},

    orderStatus: 1, //活动订单状态 1:可创建订单状态 2:订单未⽀付状态 3:订单已⽀付状态
    orderId: '',
    /**
     * 活动状态 -1：活动已结束 -2:未报名，活动报名结束
     */
    activityState: null,
  },
  actions: {
    fetActInfo() {
      return async dispatch => {
        const { data } = await getWishActInfo()
        if (data) {
          const { registrationInfoVo, activityInfoVo, orderInfoVo, state } = data
          dispatch(
            duck.change({
              actLoading: 1,
              registrationInfoVo,
              activityInfoVo,
              ...orderInfoVo,
              activityState: state,
            }),
          )
        }
        return false
      }
    },

    signUp() {
      // /api/mall/proxy/wishchallenge/sign_up
      return async dispatch => {
        const { error } = await signUp()
        if (!error) {
          Toast.show({
            icon: 'success',
            content: '报名成功',
          })
          return true
        } else {
          Toast.show(error.message || '报名失败')
          return false
        }
        // dispatch(
        //   duck.change({
        //     actLoading: 1,
        //     registrationInfoVo,
        //     activityInfoVo,
        //     ...orderInfoVo,
        //   }),
        // )
      }
    },
  },
})
